import React from 'react';
import { withRouter } from 'react-router';
import { IonAlert, IonButton, isPlatform } from '@ionic/react';
import { getConfig } from '../../appConfig';
import { connect } from 'react-redux';
import { withTranslation } from '../../lib/translate';
import { addToAppleWallet, addToWallet, loading, showToast, updateProfile } from '../../store/actions';
import Basket from '../../lib/basket';
import googleWalletIcon from '../../assets/images/google-wallet-button.png';
import appleWalletIcon from '../../assets/images/apple-wallet.png';

class AddToWallet extends React.Component {
  state = { nearbyPrompt: null }; // 'apple' | 'google' | null

  // SPRIN-888: ask once per add whether the pass should show up near the client's locations.
  // Dismissing the prompt (backdrop/back) just closes it - the pass is added only after Yes/No.
  askNearby = (platform) => {
    const passkitConfig = this.getPasskitConfig();
    if (!(passkitConfig.locations || []).length) {
      return this.addPass(platform, true);
    }
    this.setState({ nearbyPrompt: platform });
  };

  addPass = (platform, nearby) => {
    this.setState({ nearbyPrompt: null });
    this.props.dispatch(updateProfile({ wallet_pass_nearby: !!nearby }, true));
    platform === 'apple' ? this.createApplePass(nearby) : this.onClickHandler();
  };

  getPasskitConfig = () => {
    const config = getConfig();
    const passkitConfig = config.passkitConfig || {};
    if (!passkitConfig.googleClassId) {
      const defaultGoogle = config.defaultGoogleLoyaltyObject || {};
      passkitConfig.googleClassId = defaultGoogle.classId || '';
      passkitConfig.barcodeAlternateText = passkitConfig.barcodeAlternateText || defaultGoogle?.barcode?.alternateText || 'Scan QR code!';
    }
    return passkitConfig;
  };

  getCurrentTierData = () => {
    const { profile } = this.props;
    const { hasLoyaltyTiers } = getConfig().flags;
    if (hasLoyaltyTiers && profile?.current_tier?.current_tier_id) {
      return getConfig().tiers_json?.find(tier => tier.id == profile.current_tier.current_tier_id) || null;
    }
    return null;
  };

  getStampCards = () => {
    const { profile } = this.props;
    const configStampCards = getConfig()?.stamp_cards_json || [];
    return (profile?.stamp_cards_json || []).map(userCard => {
      const configCard = configStampCards.find(c => c.id === userCard.stampcard || c.id === userCard.id);
      return {
        stampCardBalance: userCard.stamp_balance || 0,
        stampCardMax: configCard?.stamps_required || 0,
        stampCardLabel: configCard?.title || 'Stamps',
      };
    });
  };

  getMemberships = () => {
    const { profile } = this.props;
    return (profile?.memberships || [])
      .filter(m => m.name && m.name.trim())
      .map(m => ({
        tier: m.name,
        tierBannerUrl: m.styles?.banner_image || '',
      }));
  };

  onClickHandler = () => {
    const { hasWalletPassLiveUpdate } = getConfig().flags;
    const passkitConfig = this.getPasskitConfig();
    const { clientProfile, profile, vouchers } = this.props;
    const currentTierData = this.getCurrentTierData();
    let loyaltyObject = {
      classId: passkitConfig.googleClassId,
      reviewStatus: 'underReview',
      state: 'ACTIVE',
      email: profile.email,
      accountName: `${profile.first_name} ${profile.last_name}`,
      barcode: {
        alternateText: passkitConfig.barcodeAlternateText || 'Scan QR code!',
        type: 'QR_CODE',
        value: profile.qr_code,
      },
      logo: passkitConfig.logo,
      banner: passkitConfig.banner,
      // Google nearby is class-level (shared by every user of the client) and passkit PUTs the class on
      // each add, so the per-user answer is only stored on the profile here - never strip locations.
      locations: passkitConfig.locations || [],
      pointsBalance: profile.available_balance,
      pointsValue: Basket.calculatePointsAppliedPrice(profile.available_balance),
      currencyCode: passkitConfig.currencyCode || 'GBP',
      tier: currentTierData?.name || '',
      tierBannerUrl: currentTierData?.icon || '',
      stampCards: this.getStampCards(),
      memberships: this.getMemberships(),
      vouchers: vouchers,
      passkitConfig: passkitConfig,
    };
    if(hasWalletPassLiveUpdate){
			loyaltyObject = {
				...loyaltyObject,
				hostname: getConfig().api.baseURL,
				clientName: clientProfile.name,
				userId: profile.id
			};
		}
    this.props.dispatch(addToWallet(loyaltyObject));
  };

  createApplePass(nearby = true) {
    const { clientProfile, profile, vouchers, dispatch, __ } =  this.props;
    const { hasWalletPassLiveUpdate } = getConfig().flags
    const passkitConfig = this.getPasskitConfig();
    const currentTime = new Date().getTime();
    const passName = currentTime + '_' + new Date().toISOString().split('T')[0].replace(/-/gi, '');
    const serialNumber = `${(clientProfile.name || '').toLocaleLowerCase()}.@.${profile.id}`;
    const currentTierData = this.getCurrentTierData();
    let appleWalletdata = {
      ...passkitConfig,
      locations: nearby ? passkitConfig.locations || [] : [],
      name: profile?.first_name,
      lastName: profile?.last_name,
      brand: clientProfile?.buisiness_name,
      qr: profile?.qr_code || "",
      bgColor: passkitConfig?.bgColor || 'rgb(200,225,251)',
      color: passkitConfig?.color || 'rgb(0,0,0)',
      passName: passName,
      serialNumber: serialNumber,
      pointsBalance: profile.available_balance,
      pointsValue: Basket.calculatePointsAppliedPrice(profile.available_balance),
      currencyCode: passkitConfig.currencyCode || 'GBP',
      tier: currentTierData?.name || '',
      tierBannerUrl: currentTierData?.icon || '',
      stampCards: this.getStampCards(),
      memberships: this.getMemberships(),
      vouchers: vouchers,
      passkitConfig: passkitConfig,
    };
    if(hasWalletPassLiveUpdate){
			appleWalletdata = {
				...appleWalletdata,
				hostname: getConfig().api.baseURL,
				clientName: clientProfile.name,
				userId: profile.id
			};	
		}
    this.props.dispatch(addToAppleWallet(appleWalletdata, (message, status)=> { 
      dispatch(loading(false));
      dispatch(showToast (__(message), status));
    }));
  }

  formatAppleWalletUrl = () => {
    const { clientProfile, profile, vouchers } =  this.props;
    const { hasWalletPassLiveUpdate } = getConfig().flags
		const nativeWallet = getConfig().api.nativeWallet;
		const passkitConfig = this.getPasskitConfig();
    const currentTime = new Date().getTime();
    const passName = currentTime + '_' + new Date().toISOString().split('T')[0].replace(/-/gi, '');
    const serialNumber = `${(clientProfile.name || '').toLocaleLowerCase()}.@.${profile.id}`;
    const currentTierData = this.getCurrentTierData();
    let urlObject = {
		  ...passkitConfig,
		  name: profile?.first_name,
      lastName: profile?.last_name,
      brand: clientProfile?.buisiness_name,
      qr: profile?.qr_code,
      bgColor: passkitConfig?.bgColor || 'rgb(200,225,251)',
      color: passkitConfig?.color || 'rgb(0,0,0)',
      passName: passName,
      serialNumber: serialNumber,
      pointsBalance: profile.available_balance,
      pointsValue: Basket.calculatePointsAppliedPrice(profile.available_balance),
      currencyCode: passkitConfig.currencyCode || 'GBP',
      tier: currentTierData?.name || '',
      tierBannerUrl: currentTierData?.icon || '',
      stampCards: JSON.stringify(this.getStampCards()),
      memberships: JSON.stringify(this.getMemberships()),
      vouchers: JSON.stringify(vouchers),
		};
    if(hasWalletPassLiveUpdate){
			urlObject = {
				...urlObject,
				hostname: getConfig().api.baseURL,
				clientName: clientProfile.name,
				userId: profile.id
			};	
		}
		const urlArray = [];
		Object.keys(urlObject).forEach((key) => {
		  if (!urlObject[key]) delete urlObject[key];
		});
		for (var p in urlObject)
		  if (urlObject.hasOwnProperty(p)) {
			urlArray.push(`${encodeURIComponent(p)}=${encodeURIComponent(urlObject[p])}`);
		  }
		urlArray.push('target="_system"');
		return `${nativeWallet}/apple-wallet?${urlArray.join('&')}`;
	};

  renderNearbyPrompt() {
    const { __, clientProfile } = this.props;
    const { nearbyPrompt } = this.state;
    const brand = clientProfile?.buisiness_name || clientProfile?.name || '';
    const wallet = nearbyPrompt === 'apple' ? 'Apple Wallet' : 'Google Wallet';
    return (
      <IonAlert
        isOpen={!!nearbyPrompt}
        message={__('Get a {wallet} notification when you are near a {brand} location?', { wallet, brand })}
        buttons={[
          { text: __('No'), role: 'no', cssClass: 'secondary', handler: () => this.addPass(nearbyPrompt, false) },
          { text: __('Yes'), role: 'yes', cssClass: 'primary', handler: () => this.addPass(nearbyPrompt, true) },
        ]}
        onDidDismiss={() => this.setState({ nearbyPrompt: null })}
      />
    );
  }

  render() {
    const { hasAddToAppleWallet, hasAddToGoogleWallet } = getConfig().flags;
    if (hasAddToAppleWallet && isPlatform('ios')) {
      return (
        <>
          <a className="wallet-button" onClick={() => this.askNearby('apple')}>
            <img src={appleWalletIcon} />
          </a>
          {this.renderNearbyPrompt()}
        </>
      );
    } else if (hasAddToGoogleWallet && isPlatform('android')) {
      return (
        <>
          <IonButton className="wallet-button" onClick={() => this.askNearby('google')}>
            <img src={googleWalletIcon} />
          </IonButton>
          {this.renderNearbyPrompt()}
        </>
      );
    }
    return null;
  }
}

const stateToProps = (state) => {
  const { profile, vouchers } = state.profile;
  const { clientProfile } = state.common;
  return {
    profile: profile,
    clientProfile: clientProfile,
    vouchers: vouchers || []
  };
};

export default connect(stateToProps)(withRouter(withTranslation(AddToWallet)));
